<template>
    <form-wrapper class="form__fields" :isSubmittable="false">
        <div class="auth-register-with-npi-form">
            <text-field
                :label="$t('forms.auth.profile.fields.npi_number.label')"
                :placeholder="$t('forms.auth.profile.fields.npi_number.placeholder')"
                :isRequired="true"
                :hasAutofocus="true"
                :formData="data"
                :error="npiErrorMessage"
                valuePath="npiNumber"
                @change="change($event)"
            ></text-field>

            <common-buttons class="npi-number-not-found-buttons">
                <common-button
                    :label="$t('forms.auth.profile.fields.npi_number.verify')"
                    :isProcessing="isLoading"
                    type="primary"
                    size="small"
                    @click="matchProviderData"
                ></common-button>
            </common-buttons>
            <common-divider></common-divider>
            <span class="no-npi-text">
                {{ $t('pages.auth.signup.dont_have_npi') }}
            </span>
            <span class="npi-number-not-found" @click="emitEvent({ name: 'go-wtihout-npi' })">
                {{ $t('pages.auth.signup.start_new_registration') }}
            </span>
            <span class="text-or">
                {{ $t('pages.auth.signup.steps.register.description.or') }}
            </span>
            <router-link :to="{ name: 'auth.login' }" class="npi-number-not-found">
                {{ $t('pages.auth.signup.steps.register.description.login') }}
            </router-link>
        </div>
    </form-wrapper>
</template>

<script>
    import FormMixin from 'mixins/FormMixin'
    import ProviderDatabaseAPI from 'api/ProviderDatabaseAPI'

    export default {
        mixins: [FormMixin],

        data() {
            return {
                isLoading: false,
                npiErrorMessage: '',
            }
        },

        methods: {
            matchProviderData() {
                if (this.data.npiNumber.length !== 10) {
                    this.npiErrorMessage = this.$t('pages.auth.signup.npi_number_must_be_10_digits')
                    return
                }
                this.isLoading = true
                ProviderDatabaseAPI.get(this.data.npiNumber)
                    .then((res) => {
                        this.$router.push({ name: 'auth.signup.register', query: { npi: this.data.npiNumber } })
                        this.emitEvent({ name: 'provider-data-matched', payload: res })
                    })
                    .catch(() => {
                        this.npiErrorMessage = this.$t('pages.auth.signup.npi_number_not_found')
                    })
                    .finally(() => {
                        this.isLoading = false
                    })
            },
        },
    }
</script>

<style scoped lang="scss">
    @import 'styles/setup/_variables.scss';

    .auth-register-with-npi-form {
        display: flex;
        flex-direction: column;
        gap: 5px;
    }

    .npi-number-not-found {
        text-align: center;
        cursor: pointer;
        color: $color--accent-1;
    }
    .text-or {
        text-align: center;
    }
    .no-npi-text {
        font-size: 14px;
        font-weight: bold;
        color: $color--txt-header;
    }
    .npi-number-not-found-buttons {
        margin: 20px 0;
    }
</style>
